export * from './errorCode'
export * from './locale'

export * from './permission'
export * from './route'

export * from './system'

export const MAIN_CLIENT_APP_URL = import.meta.env.VITE_MAIN_CLIENT_APP_URL
export const AUTH_API_URL = import.meta.env.VITE_AUTH_API_URL
export const CIS_API_URL = import.meta.env.VITE_CIS_API_URL
export const SCHEDULER_API_URL = import.meta.env.VITE_SCHEDULER_API_URL
export const DOCUMENT_API_URL = import.meta.env.VITE_DOCUMENTS_API_URL
